import { COMPARE_ROUTES } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getCompareRoutesFromIds = async (selectedRouteIds) => {
  try {
    const resp = await apiClient.get(COMPARE_ROUTES, {
      params: { ids: selectedRouteIds },
    });
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
